import * as stylex from '@stylexjs/stylex';
import '@tokens/colors.stylex';
import { colors } from '@tokens/colors.stylex';
export const styles = {
  signatureBox: {
    kMzoRj: "xmkeg23",
    ksu8eU: "xbsl7fq",
    kVAM5u: "x1xo1f5v",
    kaIpWk: "x1q4ynmn",
    kWkggS: "x13uruat",
    kFalU9: "x5ve5x3",
    kzqmXN: "xh8yej3",
    $$css: true
  }
};